// @flow
import { catchError, map, mergeMap } from 'rxjs/operators/index';
import { of } from 'rxjs/index';
import { putNotificationsApi } from '../preferences/notifications/api';
import { setNewAlert } from '../alert/duck';
import { ofType } from 'redux-observable';

import type { HTTPError } from '../../error';
import type { Observable } from 'rxjs/index';

export type UnsubscribeAction = {
  +type: string;
  +error?: HTTPError;
};

export type UnsubscribeState = {
  isSubscribing?: boolean;
  subscribeSuccess?: boolean;
  error?: HTTPError;
};

const UNSUBSCRIBE_POST_RESUBSCRIBE_REQUEST = 'UNSUBSCRIBE_POST_RESUBSCRIBE_REQUEST';
const UNSUBSCRIBE_POST_RESUBSCRIBE_SUCCESS = 'UNSUBSCRIBE_POST_RESUBSCRIBE_SUCCESS';
const UNSUBSCRIBE_POST_RESUBSCRIBE_ERROR = 'UNSUBSCRIBE_POST_RESUBSCRIBE_ERROR';

export function editHasCampaignMailNewsletter(): UnsubscribeAction {
  return {
    type: UNSUBSCRIBE_POST_RESUBSCRIBE_REQUEST,
  };
}

export function editHasCampaignMailNewsletterSuccess(): UnsubscribeAction {
  return {
    type: UNSUBSCRIBE_POST_RESUBSCRIBE_SUCCESS,
  };
}

export function editHasCampaignMailNewsletterError(error: HTTPError): UnsubscribeAction {
  return {
    type: UNSUBSCRIBE_POST_RESUBSCRIBE_ERROR,
    error,
  };
}

export const actions = {
  UNSUBSCRIBE_POST_RESUBSCRIBE_REQUEST,
  UNSUBSCRIBE_POST_RESUBSCRIBE_SUCCESS,
  UNSUBSCRIBE_POST_RESUBSCRIBE_ERROR,
  editHasCampaignMailNewsletter,
  editHasCampaignMailNewsletterSuccess,
  editHasCampaignMailNewsletterError,
};

export const initialState: UnsubscribeState = {};

export default function reducer(state: UnsubscribeState = initialState,
                                action: UnsubscribeAction): UnsubscribeState {
  switch (action.type) {
    case UNSUBSCRIBE_POST_RESUBSCRIBE_REQUEST:
      return {
        isSubscribing: true,
      };
    case UNSUBSCRIBE_POST_RESUBSCRIBE_SUCCESS:
      return {
        subscribeSuccess: true,
      };
    case UNSUBSCRIBE_POST_RESUBSCRIBE_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function editHasCampaignMailNewsletterEpic(action$: Observable<UnsubscribeAction>): Observable<UnsubscribeAction> {
  return action$.pipe(
    ofType(UNSUBSCRIBE_POST_RESUBSCRIBE_REQUEST),
    mergeMap(_ => putNotificationsApi({ hasCampaignMailNewsletter: true }).pipe(
      map(_ => editHasCampaignMailNewsletterSuccess()),
      catchError((e: HTTPError) => {
        if (Math.round(e.code / 100) === 5) {
          return of(editHasCampaignMailNewsletterError(e),
            setNewAlert('unsubscribe', 'error', undefined, 'httpErrors.post.500'),
          );
        } else if (e.code === 400) {
          return of(editHasCampaignMailNewsletterError(e),
            setNewAlert('unsubscribe', 'error', undefined, 'httpErrors.post.400'),
          );
        }
        return of(editHasCampaignMailNewsletterError(e));
      }),
    )));
}



// WEBPACK FOOTER //
// ./src/modules/unsubscribe/duck.js